/**
 * @desc 通过SupplierIdName获取供应商信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.supplierInfoFacadeImpl.getBySupplierIdName.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/getBySupplierIdName`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
